"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsTranslation = exports.isTranslation = void 0;
const isObject_1 = __importDefault(require("lodash/isObject"));
const merge_1 = __importDefault(require("lodash/merge"));
const MOLLanguage_1 = require("../../../language/MOLLanguage");
const Exists_1 = require("../common/Exists");
const IsString_1 = require("../string/IsString");
const IsUrl_1 = require("../string/IsUrl");
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
async function isTranslation(value, args, constraints) {
    constraints = (0, merge_1.default)({}, IsTranslation.defaultConstraints, constraints);
    const existsResults = await (0, Exists_1.exists)(value, args, {
        isOptional: constraints === null || constraints === void 0 ? void 0 : constraints.isOptional,
        if: constraints === null || constraints === void 0 ? void 0 : constraints.if,
        allowEmptyString: true,
    });
    if (existsResults.pass === false || existsResults.skipped) {
        return existsResults;
    }
    if (!(0, isObject_1.default)(value)) {
        return { pass: false, message: "should be a translation object" };
    }
    for (const key of MOLLanguage_1.MOLLanguage.fn.values()) {
        const langValue = value[key];
        let isOptional = true;
        if (key === MOLLanguage_1.MOLLanguage.ENGLISH && !!constraints.hasEnglish) {
            isOptional = false;
        }
        let langValidateResult;
        if (constraints.isUrl) {
            langValidateResult = await (0, IsUrl_1.isUrl)(langValue, args, {
                isOptional,
                minLength: constraints.minLength,
                maxLength: constraints.maxLength,
                isUrlOptions: constraints.isUrlOptions,
            });
        }
        else {
            langValidateResult = await (0, IsString_1.isString)(langValue, args, {
                isOptional,
                minLength: constraints.minLength,
                maxLength: constraints.maxLength,
            });
        }
        if (!langValidateResult.pass) {
            langValidateResult.message = `${MOLLanguage_1.MOLLanguage.fn.toEnumKey(key)} ${langValidateResult.message}`;
            return langValidateResult;
        }
    }
    return { pass: true };
}
exports.isTranslation = isTranslation;
/**
 * Validates that this value is a valid translation
 */
function IsTranslation(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsTranslation",
        defaultMessage: `should be a valid translation`,
        options,
        constraints,
        validateFn: isTranslation,
    });
}
exports.IsTranslation = IsTranslation;
(function (IsTranslation) {
    IsTranslation.defaultConstraints = Object.freeze({
        hasEnglish: true,
        isUrl: false,
    });
})(IsTranslation || (exports.IsTranslation = IsTranslation = {}));
//# sourceMappingURL=IsTranslation.js.map